import { render, staticRenderFns } from "./RepReservationsDashboard.vue?vue&type=template&id=1560340c&scoped=true&"
import script from "./RepReservationsDashboard.vue?vue&type=script&lang=js&"
export * from "./RepReservationsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RepReservationsDashboard.vue?vue&type=style&index=0&id=1560340c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560340c",
  null
  
)

export default component.exports